import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';
import { getInitialLanguage } from '@/hooks/useLanguage';

i18n
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'zh',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
